import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from '@/api/service-index';
import { UserDisplayModel } from '@/api/model-index';

@Injectable({
  providedIn: 'root'
})
export class UserModelResolver implements Resolve<UserDisplayModel> {
  constructor(protected userService: UserService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserDisplayModel> {
    return this.userService.apiUserGet().pipe(map(response => response));
  }
}